export default "/50f517735fec46580f19aae3e56e9fe21614ea75/d50cc34e778c6c20c755dccf4a153599.svg";